import { HgSupportedLanguage } from '@smg-real-estate/domus';

const myRealestatePath = '/my-realestate';
const propertyDetailsPath = '/property-details';

export const BASE_PATH = {
  en: '/en/property-valuation',
  de: '/de/immobilienbewertung',
  fr: '/fr/estimation',
  it: '/it/valutazione',
};

export const VALUATION_FUNNEL_PATH = {
  en: BASE_PATH['en'] + '/price-calculator',
  de: BASE_PATH['de'] + '/preisrechner',
  fr: BASE_PATH['fr'] + '/calculateur-de-prix',
  it: BASE_PATH['it'] + '/calcolatore-dei-prezzi',
};

export const MY_PROPERTIES_LANDING_PAGE_PATH = {
  en: BASE_PATH['en'] + '/owners',
  de: BASE_PATH['de'] + '/eigentuemer',
  fr: BASE_PATH['fr'] + '/proprietaires',
  it: BASE_PATH['it'] + '/proprietari',
};

export const OVERVIEW_PAGE_PATH = {
  de: BASE_PATH['de'] + myRealestatePath,
  en: BASE_PATH['en'] + myRealestatePath,
  fr: BASE_PATH['fr'] + myRealestatePath,
  it: BASE_PATH['it'] + myRealestatePath,
};

export const SOURCE_QUERY_STRING_PARAMETER = 'source';
export enum SOURCE_QUERY_STRING_VALUES {
  HO_LANDING = 'ho_landing',
  VALUATION_FUNNEL_LANDING = 'valuation_funnel_landing',
}

export const OVERVIEW_PAGE_PATH_SOURCE_LANDING = {
  de:
    BASE_PATH['de'] +
    myRealestatePath +
    `?${SOURCE_QUERY_STRING_PARAMETER}=${SOURCE_QUERY_STRING_VALUES.HO_LANDING}`,
  en:
    BASE_PATH['en'] +
    myRealestatePath +
    `?${SOURCE_QUERY_STRING_PARAMETER}=${SOURCE_QUERY_STRING_VALUES.HO_LANDING}`,
  fr:
    BASE_PATH['fr'] +
    myRealestatePath +
    `?${SOURCE_QUERY_STRING_PARAMETER}=${SOURCE_QUERY_STRING_VALUES.HO_LANDING}`,
  it:
    BASE_PATH['it'] +
    myRealestatePath +
    `?${SOURCE_QUERY_STRING_PARAMETER}=${SOURCE_QUERY_STRING_VALUES.HO_LANDING}`,
};

export const DETAILS_PAGE_PATH = {
  de: BASE_PATH['de'] + `${propertyDetailsPath}/:id`,
  en: BASE_PATH['en'] + `${propertyDetailsPath}/:id`,
  fr: BASE_PATH['fr'] + `${propertyDetailsPath}/:id`,
  it: BASE_PATH['it'] + `${propertyDetailsPath}/:id`,
};

export const PROPERTY_EDIT_PAGE_PATH = {
  de: BASE_PATH['de'] + `${propertyDetailsPath}/:id/edit`,
  en: BASE_PATH['en'] + `${propertyDetailsPath}/:id/edit`,
  fr: BASE_PATH['fr'] + `${propertyDetailsPath}/:id/edit`,
  it: BASE_PATH['it'] + `${propertyDetailsPath}/:id/edit`,
};

export const VALUATION_FORM_PATH = {
  en: BASE_PATH['en'] + '/valuation-form',
  de: BASE_PATH['de'] + '/bewertungsformular',
  fr: BASE_PATH['fr'] + '/formulaire-evaluation',
  it: BASE_PATH['it'] + '/modulo-di-valutazione',
};

export const RESULT_PATH = {
  en: VALUATION_FUNNEL_PATH['en'] + '/result',
  de: VALUATION_FUNNEL_PATH['de'] + '/ergebnis',
  fr: VALUATION_FUNNEL_PATH['fr'] + '/resultat',
  it: VALUATION_FUNNEL_PATH['it'] + '/risultato',
};

export const RESULT_PATH_IV24 = {
  en: RESULT_PATH['en'] + '/partner',
  de: RESULT_PATH['de'] + '/partner',
  fr: RESULT_PATH['fr'] + '/partner',
  it: RESULT_PATH['it'] + '/partner',
};

export const CALLBACK_PATH_IV24 = {
  de: BASE_PATH['de'] + '/callback',
};

export const VALUATION_FUNNEL_PATH_IV24 = {
  en: VALUATION_FUNNEL_PATH['en'] + '/partner',
  de: VALUATION_FUNNEL_PATH['de'] + '/partner',
  fr: VALUATION_FUNNEL_PATH['fr'] + '/partner',
  it: VALUATION_FUNNEL_PATH['it'] + '/partner',
};

export const UBS_LANDING_PAGE_PATH = {
  en: '/c/en/lp/appraisal-confirmation',
  de: '/c/de/lp/schaetzung-bestaetigung',
  fr: '/c/fr/lp/confirmation-evaluation',
  it: '/c/it/lp/conferma-valutazione',
};

const LOCAL_LANDING_PAGE_VALID_PATH_REGEX = String.raw`[\w\-]+`;
export const LOCAL_LANDING_PAGE_PATH = {
  en: `${BASE_PATH['en']}/:location(${LOCAL_LANDING_PAGE_VALID_PATH_REGEX})`,
  de: `${BASE_PATH['de']}/:location(${LOCAL_LANDING_PAGE_VALID_PATH_REGEX})`,
  fr: `${BASE_PATH['fr']}/:location(${LOCAL_LANDING_PAGE_VALID_PATH_REGEX})`,
  it: `${BASE_PATH['it']}/:location(${LOCAL_LANDING_PAGE_VALID_PATH_REGEX})`,
};

const listingPath = '/listing/:objectReference';
export const LISTING_REDIRECT_PATHS = {
  en: `${BASE_PATH['en']}${listingPath}`,
  de: `${BASE_PATH['de']}${listingPath}`,
  fr: `${BASE_PATH['fr']}${listingPath}`,
  it: `${BASE_PATH['it']}${listingPath}`,
};

export const HG_ACCOUNT_BASE_PATH = 'https://www.homegate.ch';
export const HG_BASE_PATH = 'https://www.homegate.ch';
export const IS24_BASE_PATH = 'https://www.immoscout24.ch';
export const ARTICLE_API_PATH = (language: HgSupportedLanguage) =>
  `/c/api/${language}/teaserpool/teaser-pool-propertyevaluation.json`;
